import { useCallback, useState } from 'react';
import { useInterval } from '@frontend/design-system';
import { useCalendarGridStore } from '../../../store/calendar-grid.store';
import { timezoneToTimeIndicatorInfo } from '../../../utils';
import { TimeIndicator } from './time-indicator';

const TIME_INDICATOR_UPDATE_INTERVAL = 60000; // Update every minute

interface Props {
  gridColumn: string;
  timezone?: string;
}

export const TodayTimeIndicator = ({ gridColumn, timezone }: Props) => {
  const timeIndicatorLines = useCalendarGridStore((s) => s.timeIndicatorLines);
  const [timeIndicatorInfo, setTimeIndicatorInfo] = useState<[string, number] | undefined>(
    timezoneToTimeIndicatorInfo(timezone)
  );

  const updateTimeIndicatorInfo = useCallback(() => {
    if (!timezone || timeIndicatorLines === 'none') return;

    const info = timezoneToTimeIndicatorInfo(timezone);
    if (info) setTimeIndicatorInfo(info);
  }, [timezone, timeIndicatorLines]);

  useInterval(updateTimeIndicatorInfo, TIME_INDICATOR_UPDATE_INTERVAL);

  if (!timezone || timeIndicatorLines === 'none') return null;

  if (!timeIndicatorInfo) return null;

  const [currentTime, rowNumber] = timeIndicatorInfo;

  return <TimeIndicator gridColumn={gridColumn} rowNumber={rowNumber} label={currentTime} />;
};
